// Readers
import { paymentReader } from "../../../readers";

const isPaymentReverted = (payment) => paymentReader.status(payment) === "revert";

export { isPaymentReverted };
